/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import examType1Actions from '../../../../../../../redux/actions/examType1Actions';

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(4),
  },
  buttonRoot: {
    padding: '0 2em',
  },
}));

const MCQAnswers = ({
  answers, currentAnswer, setCurrentAnswer, questionId, multiQuestionId,
}) => {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles();

  return (
    <Grid container direction="row">
      {
        answers.map((answer, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            className={classes.buttonRoot}
            key={answer.text}
          >
            <Button
              className={classes.button}
              variant={currentAnswer && currentAnswer.length > 0 ? (currentAnswer[multiQuestionId].answerIndex[0] === index ? 'contained' : 'outlined') : 'outlined'}
              color="primary"
              style={{ fontSize: 19, lineHeight: 1.5 }}
              onClick={() => setCurrentAnswer([{ question: questionId, answerIndex: [index], created_at: new Date() }])}
              fullWidth
            >
              {answer.text}
            </Button>
          </Grid>
        ))
      }
    </Grid>
  );
};

MCQAnswers.propTypes = {
  answers: PropTypes.array.isRequired,
  currentAnswer: PropTypes.array.isRequired,
  questionId: PropTypes.string.isRequired,
  setCurrentAnswer: PropTypes.func.isRequired,
  multiQuestionId: PropTypes.number.isRequired,
};

const actionCreators = {
  setCurrentAnswer: examType1Actions.setCurrentAnswer,
};

export default connect(null, actionCreators)(MCQAnswers);
